import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createAccessToken, getAccessTokens, revokeAccessToken } from "../services/hub";
import { CreateAccessToken } from "../types/auth";
import { errorMessage } from "../utils/toast";

export const useAccessTokens = () => {
    return useQuery({
        queryKey: ['accessTokens'],
        queryFn: async () => (await getAccessTokens()).data.data,
        retry: false,
    });
}

export const useCreateAccessToken = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CreateAccessToken) => createAccessToken(data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['accessTokens'] }),
        onError: (error) => errorMessage(error),
    });
}

export const useRevokeAccessToken = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, password }: { id: string; password: string }) => revokeAccessToken(id, password),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['accessTokens'] }),
        onError: (error) => errorMessage(error),
    });
}
